export const languages: { code: string, flag: string, name: string, label: string }[] = [
    { code: "nl", flag: "nl", name: "Nederlands", label: "languages.nl" },
    { code: "en", flag: "gb", name: "English", label: "languages.en" },
    { code: "de", flag: "de", name: "German", label: "languages.de" },
    { code: "it", flag: "it", name: "Italian", label: "languages.it" },
    { code: "es", flag: "es", name: "Spanish", label: "languages.es" },
    { code: "fr", flag: "fr", name: "French", label: "languages.fr"},
    { code: "other", flag: "other", name: "Other", label: "languages.other" },
];